import React from 'react'
import PropTypes from 'prop-types'
import Buttons from 'sidecar-ui/lib/Buttons'
import ContinueButton from 'sidecar-ui/lib/Button/ContinueButton'
import InputText from 'sidecar-ui/lib/InputText'
import Notification from 'sidecar-ui/lib/Notification'
import {
  BodyRow,
  FullColumn,
  Grid,
  GridRow,
  InputCell,
} from 'sidecar-ui/lib/layout'

import enhance from './enhance'
import {
  Panel,
  PanelBody,
  ForgotBtn,
  BodyContent,
  LoginWarning,
} from './styles'
import Notifications from 'components/_common/Notifications'

const Login = ({ emailRef, handleSubmit, loginMessage, loginError, busy }) => (
  <BodyRow>
    {/* this <form> is to get mobile to show 'next'
        button on keyboard for each field */}
    <form action="">
      <BodyContent>
        <FullColumn>
          <Panel>
            <PanelBody>
              <h1>Partner login</h1>

              <Notifications domain="login" />

              {loginError && (
                <Notification
                  data-qaid="info_pageError"
                  note={{ type: 'error', text: loginError }}
                />
              )}

              {loginMessage && (
                <Notification
                  data-qaid="info_pageMessage"
                  note={{ type: 'success', text: loginMessage }}
                />
              )}

              <Grid>
                <GridRow>
                  <InputCell>
                    <InputText
                      innerRef={emailRef}
                      type="email"
                      name="email"
                      label="Email"
                      data-qaid="input_email"
                    />
                  </InputCell>
                  <InputCell>
                    <InputText
                      type="password"
                      name="password"
                      label="Password"
                      data-qaid="input_password"
                    />
                  </InputCell>
                </GridRow>
              </Grid>

              <Buttons full>
                <ContinueButton
                  onClick={handleSubmit}
                  data-qaid="btn_login"
                  label="Login"
                  busy={busy}
                />
                <ForgotBtn to="/forgot" data-qaid="link_forgot">
                  Forgot your password?
                </ForgotBtn>
              </Buttons>
            </PanelBody>
          </Panel>
          <LoginWarning>
            <Notification
              note={{
                type: 'warn',
                text: (
                  <div>
                    If you have onboarded after 03/25/2022, your login might not
                    work yet. We will notify you via email when your account is
                    ready. If you have any questions, contact us at{' '}
                    <a href="mailto:email">broker@sidecarhealth.com</a>
                  </div>
                ),
              }}
            ></Notification>
          </LoginWarning>
        </FullColumn>
      </BodyContent>
    </form>
  </BodyRow>
)

Login.propTypes = {
  handleSubmit: PropTypes.func,
}

export default enhance(Login)



// WEBPACK FOOTER //
// ./src/pages/Login/index.js